import { useTheme } from 'styled-components';
import _ from 'lodash';
import { ComponentType } from 'react';
import { StyledSvgIcon } from './Icon.styled';
import * as icons from './Icons';

interface IconSvgProps {
  icon: string;
  color?: string;
  width?: string | number;
  height?: string | number;
}

type IconComponentType = ComponentType<{
  width?: string | number;
  height?: string | number;
  color?: string;
}>;

const IconSvg = ({
  icon, color, width = '1.29rem', height = '1.29rem',
}: IconSvgProps) => {
  const { colors } = useTheme();

  const colorProp = _.isUndefined(color) ? colors.secondaryColor : color;

  const typedIcons = icons as Record<string, IconComponentType>;

  const IconComponent = typedIcons[icon];

  return IconComponent ? (
    <StyledSvgIcon color={color}>
      <IconComponent width={width} height={height} color={colorProp} />
    </StyledSvgIcon>
  ) : null;
};

export default IconSvg;
